import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Como integrar',
  version: 'v1 · JSON · HTTPS',
  subjects: {
    title: 'Busque quem autorizou',
    text: 'Feed incremental. Guarde o nextCursor e repita no seu ritmo. Quem revogou vem com status "revoked": apague tudo dessa pessoa.',
  },
  media: {
    title: 'Envie as fotos encontradas',
    text: 'Reenviar o mesmo externalId atualiza a foto. A Bodyprint junta o que chegar em 2 horas e avisa o atleta no máximo 1 vez por dia.',
  },
  rules: {
    title: 'Regras do contrato',
    threshold:
      'Envie só correspondências acima do seu limiar de confiança, documentado no contrato.',
    preview:
      'previewUrl estável, em baixa resolução e com marca d’água. A foto em alta fica com vocês.',
    usage:
      'Use os dados só para procurar mídia do atleta. Apague o que o feed substituir e tudo de quem revogou.',
    auth: 'Toda chamada leva o cabeçalho Authorization: Bearer com a sua chave. Chave revogada responde 401.',
  },
} satisfies TranslationTree;
